<template>
  <div class="container">
    <div class="body">
      <v-text-field
        autofocus
        filled
        background-color="textBoxBackground"
        label="Name"
        style="height: 66px"
        v-model="userEditObj.name"
        @keyup.enter="$emit('request-save')"></v-text-field>
      <v-textarea
        filled
        height="400"
        no-resize
        background-color="textBoxBackground"
        label="Description"
        v-model="userEditObj.description"></v-textarea>
      <v-window
        style="flex-grow: 1"
        show-arrows
        v-if="getAssets(userEditObj).length > 0">
        <template v-slot:prev="{ props }">
          <v-btn
            color="primary"
            rounded
            variant="flat"
            @click="props.onClick">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </template>
        <template v-slot:next="{ props }">
          <v-btn
            color="primary"
            rounded
            variant="flat"
            @click="props.onClick">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </template>
        <v-window-item
          v-for="asset in getAssets(userEditObj)"
          style="height: 100%">
          <AssetPreview
            :selected="asset"
            :height="'100%'" />
        </v-window-item>
      </v-window>
    </div>
  </div>
</template>

<script setup>
import { deluge } from '../../../stores/deluge';
import { defineProps } from 'vue';
import AssetPreview from '../../Assets/AssetPreview.vue';
const props = defineProps(['userEditObj']);
function getAssets(scene) {
  var assets = [];
  if (scene) {
    for (const svar in scene.svars) {
      if (scene.svars[svar].type === 'asset') {
        if (scene.svars[svar]) {
          if (deluge.assets[scene.svars[svar].value]) {
            assets.push(deluge.assets[scene.svars[svar].value]);
          }
        }
      }
    }
  }
  return assets;
}
</script>

<style scoped></style>
